module.exports = __webpack_public_path__ + "static/img/back.fd4e440.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back.png
// module id = DtD7
// module chunks = 1